// extracted by mini-css-extract-plugin
export default {"coverImage":"style_coverImage__9FD51","dialogBox":"style_dialogBox__gFs86"};